<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm()"
  (cancel)="cancel()"
  data-test="create-variety-property-dialog"
>
  <div class="flex--container">
    <!-- CropVarietyName select box -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'varietyProperties.cropVarietyName' | translate }}</mat-label>
        <input
          type="text"
          matInput
          formControlName="ediCode"
          [matAutocomplete]="cropVarietyAutocomplete"
          data-test="create-variety-property-crop-variety-name"
        />
        <mat-autocomplete
          #cropVarietyAutocomplete="matAutocomplete"
          [displayWith]="displayCropVariety()"
        >
          @for (cropVariety of filteredCropVarieties$ | async; track cropVariety) {
            <mat-option [value]="cropVariety.ediCode" [disabled]="isEditMode">
              {{ cropVariety.name }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (formGroup.controls.ediCode.hasError('required')) {
          <mat-error> {{ 'varietyProperties.cropVarietyName' | translate }} is required </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Maturity input -->
    <div class="flex--row flex--gutter">
      <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
        <mat-label>{{ 'varietyProperties.maturity' | translate }}</mat-label>
        <input
          matInput
          formControlName="maturity"
          agrNumber
          appDecimalSeparator
          step="0.1"
          data-test="create-variety-property-maturity"
        />
        @if (
          formGroup.controls.maturity.hasError('min') || formGroup.controls.maturity.hasError('max')
        ) {
          <mat-error>
            {{ 'varietyProperties.maturity' | translate }} must be between 0.1 and 999.9
          </mat-error>
        }
        @if (formGroup.controls.maturity.hasError('required')) {
          <mat-error> {{ 'varietyProperties.maturity' | translate }} is required </mat-error>
        }
        @if (formGroup.controls.maturity.hasError('decimal')) {
          <mat-error>
            {{ formGroup.controls.maturity.getError('decimal') }}
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div formGroupName="categories">
      <mat-accordion class="categories-accordion">
        @for (cat of orderedCategories; track cat) {
          <mat-expansion-panel
            [disabled]="!isCategoryActive(cat.id)"
            [hideToggle]="!isCategoryActive(cat.id)"
            [ngClass]="{ 'inactive-panel': !isCategoryActive(cat.id) }"
          >
            <mat-expansion-panel-header [ngClass]="{ 'panel-header': !isCategoryActive(cat.id) }">
              <div class="panel-container">
                <mat-panel-title class="inactive-title">
                  {{ displayProductionPurposeName(cat.name) }} ({{ cat.name }})
                </mat-panel-title>
                <mat-panel-description>
                  @if (!isCategoryActive(cat.id)) {
                    <button
                      mat-icon-button
                      color="primary"
                      class="add-category-button"
                      (click)="$event.stopPropagation(); addCategory(cat.id)"
                    >
                      <mat-icon>add</mat-icon>
                    </button>
                  }
                </mat-panel-description>
              </div>
            </mat-expansion-panel-header>
            @if (isCategoryActive(cat.id)) {
              <div [formGroupName]="cat.id.toString()">
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.foliageMax' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="foliageMax"
                      agrNumber
                      appDecimalSeparator
                      step="1"
                      [attr.data-test]="'create-variety-property-foliage-max-' + cat.id"
                    />
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'foliageMax'])
                        .hasError('min') ||
                      formGroup.get(['categories', cat.id.toString(), 'foliageMax']).hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.foliageMax' | translate }} must be between 1 and 99999
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'foliageMax'])
                        .hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.foliageMax' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'foliageMax'])
                        .hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'foliageMax'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.day50Percent' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="day50Percent"
                      agrNumber
                      appDecimalSeparator
                      step="0.1"
                      [attr.data-test]="'create-variety-property-day50-' + cat.id"
                    />
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'day50Percent'])
                        .hasError('min') ||
                      formGroup
                        .get(['categories', cat.id.toString(), 'day50Percent'])
                        .hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.day50Percent' | translate }} must be between 0.1 and
                        100
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'day50Percent'])
                        .hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.day50Percent' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'day50Percent'])
                        .hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'day50Percent'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.nEfficiency' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="nEfficiency"
                      agrNumber
                      appDecimalSeparator
                      step="0.01"
                      [attr.data-test]="'create-variety-property-n-efficiency-' + cat.id"
                    />
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'nEfficiency'])
                        .hasError('min') ||
                      formGroup
                        .get(['categories', cat.id.toString(), 'nEfficiency'])
                        .hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.nEfficiency' | translate }} must be between 0.01 and
                        100
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'nEfficiency'])
                        .hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.nEfficiency' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'nEfficiency'])
                        .hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'nEfficiency'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.nMax' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="nMax"
                      agrNumber
                      appDecimalSeparator
                      step="1"
                      [attr.data-test]="'create-variety-property-nMax-' + cat.id"
                    />
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'nMax']).hasError('min') ||
                      formGroup.get(['categories', cat.id.toString(), 'nMax']).hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.nMax' | translate }} must be between 1 and 99999
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'nMax']).hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.nMax' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'nMax']).hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'nMax'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.nNorm' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="nNorm"
                      agrNumber
                      appDecimalSeparator
                      step="1"
                      [attr.data-test]="'create-variety-property-nNorm-' + cat.id"
                    />
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'nNorm']).hasError('min') ||
                      formGroup.get(['categories', cat.id.toString(), 'nNorm']).hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.nNorm' | translate }} must be between 1 and 99999
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'nNorm']).hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.nNorm' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'nNorm']).hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'nNorm'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.kMin' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="kMin"
                      agrNumber
                      appDecimalSeparator
                      step="1"
                      [attr.data-test]="'create-variety-property-kMin-' + cat.id"
                    />
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'kMin']).hasError('min') ||
                      formGroup.get(['categories', cat.id.toString(), 'kMin']).hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.kMin' | translate }} must be between 1 and 99999
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'kMin']).hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.kMin' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'kMin']).hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'kMin'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.kMax' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="kMax"
                      agrNumber
                      appDecimalSeparator
                      step="1"
                      [attr.data-test]="'create-variety-property-kMax-' + cat.id"
                    />
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'kMax']).hasError('min') ||
                      formGroup.get(['categories', cat.id.toString(), 'kMax']).hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.kMax' | translate }} must be between 1 and 99999
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'kMax']).hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.kMax' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'kMax']).hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'kMax'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.giftcorrection' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="giftcorrection"
                      agrNumber
                      appDecimalSeparator
                      step="0.01"
                      [attr.data-test]="'create-variety-property-giftcorrection-' + cat.id"
                    />
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'giftcorrection'])
                        .hasError('min') ||
                      formGroup
                        .get(['categories', cat.id.toString(), 'giftcorrection'])
                        .hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.giftcorrection' | translate }} must be between 0.01
                        and 1
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'giftcorrection'])
                        .hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.giftcorrection' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'giftcorrection'])
                        .hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'giftcorrection'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.plantHa' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="plantHa"
                      agrNumber
                      appDecimalSeparator
                      step="0.01"
                      [attr.data-test]="'create-variety-property-plant-ha-' + cat.id"
                    />
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'plantHa']).hasError('min') ||
                      formGroup.get(['categories', cat.id.toString(), 'plantHa']).hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.plantHa' | translate }} must be between 0.01 and 1
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'plantHa'])
                        .hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.plantHa' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup
                        .get(['categories', cat.id.toString(), 'plantHa'])
                        .hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'plantHa'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.mgMin' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="mgMin"
                      agrNumber
                      appDecimalSeparator
                      step="1"
                      [attr.data-test]="'create-variety-property-mgMin-' + cat.id"
                    />
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'mgMin']).hasError('min') ||
                      formGroup.get(['categories', cat.id.toString(), 'mgMin']).hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.mgMin' | translate }} must be between 0 and 99999
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'mgMin']).hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.mgMin' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'mgMin']).hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'mgMin'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="flex--row flex--gutter">
                  <mat-form-field class="flex__child--auto min-width-350" appearance="outline">
                    <mat-label>{{ 'varietyProperties.mgMax' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="mgMax"
                      agrNumber
                      appDecimalSeparator
                      step="1"
                      [attr.data-test]="'create-variety-property-mgMax-' + cat.id"
                    />
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'mgMax']).hasError('min') ||
                      formGroup.get(['categories', cat.id.toString(), 'mgMax']).hasError('max')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.mgMax' | translate }} must be between 0 and 99999
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'mgMax']).hasError('required')
                    ) {
                      <mat-error>
                        {{ 'varietyProperties.mgMax' | translate }} is required
                      </mat-error>
                    }
                    @if (
                      formGroup.get(['categories', cat.id.toString(), 'mgMax']).hasError('decimal')
                    ) {
                      <mat-error>
                        {{
                          formGroup
                            .get(['categories', cat.id.toString(), 'mgMax'])
                            .getError('decimal')
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            }
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  </div>
</agr-form-dialog>
